/* eslint-disable react/prop-types */
import React from "react";
import { motion } from "framer-motion";
import { IMAGE_URL } from "../../../constants";
import { Link } from "react-router-dom";

const BookFlipCard = ({ book }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Link to={book?.external_link}>
      <div
        className="relative w-full h-full overflow-hidden cursor-pointer aspect-square"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Front - Book Cover */}
        <img
          src={`${IMAGE_URL}/${book?.image}`}
          alt={book.author_name}
          className="object-cover w-full h-full rounded-lg shadow-lg"
        />

        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: isHovered ? "0%" : "100%" }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="absolute inset-0 flex flex-col items-center justify-center w-full h-full p-4 text-white bg-indigo-900 rounded-lg shadow-lg"
        >
          <p className="mb-2 text-sm">By {book.author_name}</p>
          {book?.name && <p className="mb-2 text-sm">By {book.name}</p>}
        </motion.div>
      </div>
    </Link>
  );
};

export default BookFlipCard;
